module.exports = __webpack_public_path__ + "img/interior_16.f3032149.jpg";